"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tracking_handler_1 = require("../../utils/browser/tracking-handler");
class GroupCardComponent extends Marko.Component {
    handleMenuSelect(event) {
        const { index } = event;
        const { overflowMenu } = this.input;
        const menuItems = (overflowMenu === null || overflowMenu === void 0 ? void 0 : overflowMenu.menuItems) || [];
        if (typeof index === 'number' &&
            index >= 0 &&
            index < menuItems.length) {
            const { trackingData } = menuItems[index];
            (0, tracking_handler_1.handleTracking)(trackingData);
        }
    }
}
exports.default = GroupCardComponent;
